import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { CstmPagination } from "../../../../components/Common/Common";

// img
import user from "../../../../Assets/images/user.png";
import doc from "../../../../Assets/images/doc.png";
import { GET_DRIVER_VIEW } from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import Table from "../../../../components/Common/Table";
import moment from "moment";
import Slider from "react-slick";
import { noImgPLaceHolder } from "../../../../utilities/const";

const DriverDetail = () => {
  const { id } = useParams();

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const [driverDetails, setDriverDetail] = useState();
  const getDriver = async () => {
    try {
      const res = await GET_DRIVER_VIEW(id);
      if (res?.status === 200) {
        setDriverDetail(res?.data);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    if (id) getDriver();
  }, [id]);

  const col = [
    {
      label: "Booking Id",
      id: "bookingNumber",
    },
    {
      label: "Customer Name",
      id: "customerName",
      classNames: "fw-sbold themeBlue",
    },
    {
      label: "Total Amount",
      id: "totalAmount",
      isComponent: true,
      component: (item) => (
        <p className={` fw-sbold m-0`}>${item?.totalAmount}</p>
      ),
    },
    // {
    //   label: "Payment Method",
    //   id: "paymentMethod",
    // },
    {
      label: "Agency Earning",
      id: "adminEarning",
      classNames: "fw-sbold",
      isComponent: true,
      component: (item) => (
        <p className={` fw-sbold m-0`}>${item?.adminEarning}</p>
      ),
    },
    // {
    //   label: "Pick up location",
    //   id: "startAddress",
    //   classNames: "fw-sbold text-danger",
    // },
    // {
    //   label: "Drop Off location",
    //   id: "endAddress",
    //   classNames: "fw-sbold text-danger",
    // },
    // {
    //   label: "Status",
    //   id: "status",
    // },
    {
      label: "Status",
      id: "status",
      isComponent: true,
      component: (item) => (
        <p
          className={`${
            item.status === "rejected"
              ? "text-warning"
              : item.status === "confirmed"
                ? "text-primary"
                : "text-success"
          } m-0 fw-sbold `}
        >
          {item?.status.charAt(0).toUpperCase() + item?.status.slice(1)}
        </p>
      ),
    },
    {
      label: "Created At",
      id: "createdAt",
      isComponent: true,
      component: (item) => (
        <p className={` fw-sbold m-0`}>
          {moment(item.createdAt).format("MM/DD/YYYY")}
        </p>
      ),
    },
    {
      label: "Rating",
      isComponent: true,
      component: (item) => (
        <div className="actnBtn d-flex align-items-start justify-content-start gap-10">
          <Link
            to={`/booking-request/detail/${item.bookingId}`}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="13"
              viewBox="0 0 20 13"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99942 0C5.87279 0 2.68732 2.92137 1.14138 4.63152C0.487156 5.35521 0.112249 5.89152 0.112249 5.89152C-0.0374163 6.10585 -0.0374163 6.39244 0.112249 6.60677C0.112249 6.60677 0.40728 7.02947 0.92408 7.62251C2.37509 9.28752 5.66888 12.4983 9.99942 12.4983C14.4446 12.4983 17.8017 9.1185 19.1907 7.49319C19.6367 6.9711 19.8878 6.60677 19.8878 6.60677C20.0374 6.39244 20.0374 6.10585 19.8878 5.89152C19.8878 5.89152 19.6124 5.49478 19.126 4.93184C17.7002 3.28222 14.3781 0 9.99942 0ZM9.99942 1.25008C13.7359 1.25008 16.8553 4.21593 18.1799 5.74864C18.445 6.05541 18.47 6.10436 18.5814 6.25155C18.4776 6.38815 18.4655 6.41709 18.2396 6.68136C16.9507 8.18975 13.7927 11.2482 9.99942 11.2482C6.30393 11.2482 3.21437 8.34884 1.86524 6.80092C1.5755 6.46852 1.54441 6.40683 1.42699 6.25155C1.56293 6.07013 1.64892 5.93485 2.06799 5.47147C3.50792 3.8784 6.4779 1.25008 9.99942 1.25008ZM9.99942 2.50016C7.93553 2.50016 6.25283 4.18286 6.25283 6.24675C6.25283 8.31048 7.93553 9.99814 9.99942 9.99814C12.0631 9.99814 13.7508 8.31048 13.7508 6.24675C13.7508 4.18286 12.0631 2.50016 9.99942 2.50016ZM9.99942 3.75139C11.3878 3.75139 12.5007 4.85825 12.5007 6.24675C12.5007 7.63508 11.3878 8.74806 9.99942 8.74806C8.61092 8.74806 7.50406 7.63508 7.50406 6.24675C7.50406 4.85825 8.61092 3.75139 9.99942 3.75139Z"
                fill="#645C5C"
              />
            </svg>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <section className="DriverDetail py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-start justify-content-between gap-10 flex-wrap">
                <div className="py-2">
                  <div className="head mb-3">
                    <h4 className="m-0 themeBlue fw-sbold">Driver Details</h4>
                  </div>
                  <div className="d-flex align-items-center gap-10">
                    <div className="imgWrp rounded-circle">
                      <img
                        src={
                          driverDetails?.providerDetails?.profileImage || user
                        }
                        alt=""
                        className="img-fluid rounded-circle"
                        style={{ height: 80, width: 80 }}
                      />
                    </div>
                    <div className="content">
                      <h6 className="m-0 fw-sbold">
                        Hi, {driverDetails?.providerDetails?.name}
                      </h6>
                      <h4 className="m-0 fw-bold themeBlue d-flex align-itmes-center">
                        5.0{" "}
                        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                          <li className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.47851 0.347205C5.52571 0.243304 5.60011 0.155533 5.69308 0.0940768C5.78605 0.0326208 5.89377 0 6.00375 0C6.11373 0 6.22146 0.0326208 6.31442 0.0940768C6.40739 0.155533 6.48179 0.243304 6.52899 0.347205L8.02968 3.64741L11.4963 4.12615C11.6049 4.1415 11.7072 4.18866 11.7914 4.26221C11.8755 4.33576 11.9381 4.43269 11.9718 4.54181C12.0055 4.65094 12.0091 4.76782 11.982 4.87897C11.955 4.99012 11.8984 5.091 11.8189 5.16998L9.29026 7.68927L9.92806 11.2838C9.94748 11.3964 9.93613 11.5125 9.89531 11.6187C9.8545 11.7248 9.78587 11.8168 9.69731 11.884C9.60876 11.9513 9.50387 11.991 9.3947 11.9986C9.28553 12.0063 9.17651 11.9816 9.08017 11.9273L6.00375 10.185L2.93109 11.9273C2.83474 11.9816 2.72572 12.0063 2.61655 11.9986C2.50738 11.991 2.4025 11.9513 2.31394 11.884C2.22539 11.8168 2.15676 11.7248 2.11594 11.6187C2.07512 11.5125 2.06377 11.3964 2.0832 11.2838L2.72099 7.68927L0.181071 5.16998C0.101561 5.091 0.0450194 4.99012 0.0179707 4.87897C-0.00907805 4.76782 -0.00553186 4.65094 0.0282001 4.54181C0.061932 4.43269 0.124475 4.33576 0.208613 4.26221C0.29275 4.18866 0.395054 4.1415 0.503719 4.12615L3.97407 3.64741L5.47476 0.347205H5.47851Z"
                                fill="#FFCF38"
                              />
                            </svg>
                          </li>
                          <li className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.47851 0.347205C5.52571 0.243304 5.60011 0.155533 5.69308 0.0940768C5.78605 0.0326208 5.89377 0 6.00375 0C6.11373 0 6.22146 0.0326208 6.31442 0.0940768C6.40739 0.155533 6.48179 0.243304 6.52899 0.347205L8.02968 3.64741L11.4963 4.12615C11.6049 4.1415 11.7072 4.18866 11.7914 4.26221C11.8755 4.33576 11.9381 4.43269 11.9718 4.54181C12.0055 4.65094 12.0091 4.76782 11.982 4.87897C11.955 4.99012 11.8984 5.091 11.8189 5.16998L9.29026 7.68927L9.92806 11.2838C9.94748 11.3964 9.93613 11.5125 9.89531 11.6187C9.8545 11.7248 9.78587 11.8168 9.69731 11.884C9.60876 11.9513 9.50387 11.991 9.3947 11.9986C9.28553 12.0063 9.17651 11.9816 9.08017 11.9273L6.00375 10.185L2.93109 11.9273C2.83474 11.9816 2.72572 12.0063 2.61655 11.9986C2.50738 11.991 2.4025 11.9513 2.31394 11.884C2.22539 11.8168 2.15676 11.7248 2.11594 11.6187C2.07512 11.5125 2.06377 11.3964 2.0832 11.2838L2.72099 7.68927L0.181071 5.16998C0.101561 5.091 0.0450194 4.99012 0.0179707 4.87897C-0.00907805 4.76782 -0.00553186 4.65094 0.0282001 4.54181C0.061932 4.43269 0.124475 4.33576 0.208613 4.26221C0.29275 4.18866 0.395054 4.1415 0.503719 4.12615L3.97407 3.64741L5.47476 0.347205H5.47851Z"
                                fill="#FFCF38"
                              />
                            </svg>
                          </li>
                          <li className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.47851 0.347205C5.52571 0.243304 5.60011 0.155533 5.69308 0.0940768C5.78605 0.0326208 5.89377 0 6.00375 0C6.11373 0 6.22146 0.0326208 6.31442 0.0940768C6.40739 0.155533 6.48179 0.243304 6.52899 0.347205L8.02968 3.64741L11.4963 4.12615C11.6049 4.1415 11.7072 4.18866 11.7914 4.26221C11.8755 4.33576 11.9381 4.43269 11.9718 4.54181C12.0055 4.65094 12.0091 4.76782 11.982 4.87897C11.955 4.99012 11.8984 5.091 11.8189 5.16998L9.29026 7.68927L9.92806 11.2838C9.94748 11.3964 9.93613 11.5125 9.89531 11.6187C9.8545 11.7248 9.78587 11.8168 9.69731 11.884C9.60876 11.9513 9.50387 11.991 9.3947 11.9986C9.28553 12.0063 9.17651 11.9816 9.08017 11.9273L6.00375 10.185L2.93109 11.9273C2.83474 11.9816 2.72572 12.0063 2.61655 11.9986C2.50738 11.991 2.4025 11.9513 2.31394 11.884C2.22539 11.8168 2.15676 11.7248 2.11594 11.6187C2.07512 11.5125 2.06377 11.3964 2.0832 11.2838L2.72099 7.68927L0.181071 5.16998C0.101561 5.091 0.0450194 4.99012 0.0179707 4.87897C-0.00907805 4.76782 -0.00553186 4.65094 0.0282001 4.54181C0.061932 4.43269 0.124475 4.33576 0.208613 4.26221C0.29275 4.18866 0.395054 4.1415 0.503719 4.12615L3.97407 3.64741L5.47476 0.347205H5.47851Z"
                                fill="#FFCF38"
                              />
                            </svg>
                          </li>
                          <li className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.47851 0.347205C5.52571 0.243304 5.60011 0.155533 5.69308 0.0940768C5.78605 0.0326208 5.89377 0 6.00375 0C6.11373 0 6.22146 0.0326208 6.31442 0.0940768C6.40739 0.155533 6.48179 0.243304 6.52899 0.347205L8.02968 3.64741L11.4963 4.12615C11.6049 4.1415 11.7072 4.18866 11.7914 4.26221C11.8755 4.33576 11.9381 4.43269 11.9718 4.54181C12.0055 4.65094 12.0091 4.76782 11.982 4.87897C11.955 4.99012 11.8984 5.091 11.8189 5.16998L9.29026 7.68927L9.92806 11.2838C9.94748 11.3964 9.93613 11.5125 9.89531 11.6187C9.8545 11.7248 9.78587 11.8168 9.69731 11.884C9.60876 11.9513 9.50387 11.991 9.3947 11.9986C9.28553 12.0063 9.17651 11.9816 9.08017 11.9273L6.00375 10.185L2.93109 11.9273C2.83474 11.9816 2.72572 12.0063 2.61655 11.9986C2.50738 11.991 2.4025 11.9513 2.31394 11.884C2.22539 11.8168 2.15676 11.7248 2.11594 11.6187C2.07512 11.5125 2.06377 11.3964 2.0832 11.2838L2.72099 7.68927L0.181071 5.16998C0.101561 5.091 0.0450194 4.99012 0.0179707 4.87897C-0.00907805 4.76782 -0.00553186 4.65094 0.0282001 4.54181C0.061932 4.43269 0.124475 4.33576 0.208613 4.26221C0.29275 4.18866 0.395054 4.1415 0.503719 4.12615L3.97407 3.64741L5.47476 0.347205H5.47851Z"
                                fill="#FFCF38"
                              />
                            </svg>
                          </li>
                          <li className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.47851 0.347205C5.52571 0.243304 5.60011 0.155533 5.69308 0.0940768C5.78605 0.0326208 5.89377 0 6.00375 0C6.11373 0 6.22146 0.0326208 6.31442 0.0940768C6.40739 0.155533 6.48179 0.243304 6.52899 0.347205L8.02968 3.64741L11.4963 4.12615C11.6049 4.1415 11.7072 4.18866 11.7914 4.26221C11.8755 4.33576 11.9381 4.43269 11.9718 4.54181C12.0055 4.65094 12.0091 4.76782 11.982 4.87897C11.955 4.99012 11.8984 5.091 11.8189 5.16998L9.29026 7.68927L9.92806 11.2838C9.94748 11.3964 9.93613 11.5125 9.89531 11.6187C9.8545 11.7248 9.78587 11.8168 9.69731 11.884C9.60876 11.9513 9.50387 11.991 9.3947 11.9986C9.28553 12.0063 9.17651 11.9816 9.08017 11.9273L6.00375 10.185L2.93109 11.9273C2.83474 11.9816 2.72572 12.0063 2.61655 11.9986C2.50738 11.991 2.4025 11.9513 2.31394 11.884C2.22539 11.8168 2.15676 11.7248 2.11594 11.6187C2.07512 11.5125 2.06377 11.3964 2.0832 11.2838L2.72099 7.68927L0.181071 5.16998C0.101561 5.091 0.0450194 4.99012 0.0179707 4.87897C-0.00907805 4.76782 -0.00553186 4.65094 0.0282001 4.54181C0.061932 4.43269 0.124475 4.33576 0.208613 4.26221C0.29275 4.18866 0.395054 4.1415 0.503719 4.12615L3.97407 3.64741L5.47476 0.347205H5.47851Z"
                                fill="#FFCF38"
                              />
                            </svg>
                          </li>
                        </ul>{" "}
                      </h4>
                      <p className="m-0">
                        {driverDetails?.providerDetails?.email}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="right">
                  <Link to={`/manage-driver/edit/${id}`}>
                    <Button className="d-flex align-items-center justify-content-center commonBtn GreyBtn">
                      Edit Details
                    </Button>
                  </Link>
                </div>
              </div>
            </Col>

            <Col
              md="6"
              className="my-2"
              style={{
                height: "12rem",
              }}
            >
              <div className="py-2">
                <div className="py-2">
                  <h5 className="m-0 themeBlue fw-sbold">Document</h5>
                </div>
                <div className="cardCstm bg-white p-3 rounded ">
                  <Row>
                    <Col md="12" className="my-2">
                      <Slider {...settings}>
                        {driverDetails?.providerDetails?.documentsList?.map(
                          (item, index) => {
                            const { value, type, label } = item;

                            return (
                              <div
                                key={index}
                                className=" border d-flex flex-column text-center rounded px-3  py-2 d-flex justify-content-center align-items-center"
                              >
                                <label className="fw-bold mb-2" htmlFor="">{label}</label>
                                <div
                                  style={{
                                    height: 175,
                                    width: 250,
                                  }}
                                >
                                  {type === "file" ? (
                                    <>
                                      {value?.split(".")?.pop() === "pdf" ? (
                                        <a
                                          href={value}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          View PDF
                                        </a>
                                      ) : (
                                        <img
                                          src={value || noImgPLaceHolder}
                                          alt="document"
                                          className="img-fluid object-fit-contain"
                                          style={{
                                            width: "100%",
                                            height: "100%",

                                            cursor: "pointer",
                                          }}
                                        />
                                      )}
                                    </>
                                  ) : (
                                    <p className="m-0 text-danger w-50 fw-sbold">
                                      {value}
                                    </p>
                                  )}
                                </div>
                              </div>
                            );
                          },
                        )}
                      </Slider>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            <Col lg="6" className="my-2">
              <div className="py-2">
                <div className="py-2">
                  <h5 className="m-0 themeBlue fw-sbold">
                    Bank Account Details{" "}
                  </h5>
                </div>
                <div className="cardCstm bg-white p-3 rounded ">
                  <Row>
                    <Col md="12" className="my-2">
                      <div
                        className="cardCstm border rounded px-3 py-2"
                        style={{
                          height: "12rem",
                        }}
                      >
                        <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                          <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                            <span className="w-50 text-muted fw-sbold">
                              Bank Name:
                            </span>
                            <p className="m-0 text-danger w-50 fw-sbold">
                              {driverDetails?.accountDetails?.bankName}
                            </p>
                          </li>
                          <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                            <span className="w-50 text-muted fw-sbold">
                              Routing Number:
                            </span>
                            <p className="m-0 text-danger w-50 fw-sbold">
                              {driverDetails?.accountDetails?.routingNumber}
                            </p>
                          </li>
                          <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                            <span className="w-50 text-muted fw-sbold">
                              Account Number:
                            </span>
                            <p className="m-0 text-danger w-50 fw-sbold">
                              {" "}
                              {driverDetails?.accountDetails?.accountNumber}
                            </p>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            <Col lg="6" className="my-2">
              <div className="py-2">
                <div className="py-2">
                  <h5 className="m-0 themeBlue fw-sbold">Vehicle Details</h5>
                </div>
                <div className="cardCstm bg-white p-3 rounded">
                  <Row>
                    <Col lg="12" className="my-2">
                      <Slider {...settings}>
                        {driverDetails?.vehicleDetailsList?.map((item) => {
                          return (
                            <div
                              className="cardCstm border rounded px-3 py-2"
                              style={{
                                height: "12rem",
                              }}
                            >
                              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                                <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                                  <span className="w-50 text-muted fw-sbold">
                                    Vehicle Image:
                                  </span>
                                  <p className="m-0 text-danger w-50 fw-sbold">
                                    <img
                                      src={
                                        item?.serviceDetails?.image ||
                                        noImgPLaceHolder
                                      }
                                      style={{ height: "40px" }}
                                      className="img-fluid object-fit-contain"
                                    />
                                  </p>
                                </li>
                                <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                                  <span className="w-50 text-muted fw-sbold">
                                    Vehicle Name:
                                  </span>
                                  <p className="m-0 text-danger w-50 fw-sbold">
                                    {item?.serviceDetails?.name || "N/A"}
                                  </p>
                                </li>
                                <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                                  <span className="w-50 text-muted fw-sbold">
                                    Vehicle Type:
                                  </span>
                                  <p className="m-0 text-danger w-50 fw-sbold">
                                    {item?.serviceDetails?.type || "N/A"}
                                  </p>
                                </li>
                                <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                                  <span className="w-50 text-muted fw-sbold">
                                    Vehicle License Plate:
                                  </span>
                                  <p className="m-0 text-danger w-50 fw-sbold">
                                    {item?.plateNumber || "N/A"}
                                  </p>
                                </li>
                                <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                                  <span className="w-50 text-muted fw-sbold">
                                    Vehicle Model:
                                  </span>
                                  <p className="m-0 text-danger w-50 fw-sbold">
                                    {item?.model || "N/A"}
                                  </p>
                                </li>
                                <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                                  <span className="w-50 text-muted fw-sbold">
                                    Vehicle Make:
                                  </span>
                                  <p className="m-0 text-danger w-50 fw-sbold">
                                    {" "}
                                    {item?.make || "N/A"}
                                  </p>
                                </li>
                                <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                                  <span className="w-50 text-muted fw-sbold">
                                    Vehicle Color:
                                  </span>
                                  <p className="m-0 text-danger w-50 fw-sbold">
                                    {item?.color || "N/A"}
                                  </p>
                                </li>
                                <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                                  <span className="w-50 text-muted fw-sbold">
                                    Weight Capacity(lb):
                                  </span>
                                  <p className="m-0 text-danger w-50 fw-sbold">
                                    {item?.serviceDetails?.weightCapacity ||
                                      0}{" "}
                                  </p>
                                </li>
                              </ul>
                            </div>
                          );
                        })}
                      </Slider>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div className="py-2">
                <h5 className="m-0 themeBlue fw-sbold">Booking Details</h5>
              </div>
              <div className="table-responsive">
                <Table data={driverDetails?.bookingDetails} column={col} />
                <div className="d-flex align-items-center justify-content-end mt-2">
                  <div className="right">{/* <CstmPagination /> */}</div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DriverDetail;
